window.addEventListener('load', function() {
    const listContainers = document.querySelectorAll('.ais-RefinementList-list');

    listContainers.forEach(listContainer => {

        const listItems = Array.from(listContainer.children);

        const sortedItems = listItems.sort((a, b) => {

            if (a.innerText.includes('-')) {
                const aValue = parseFloat(a.innerText.split('-')[0].trim());
                const bValue = parseFloat(b.innerText.split('-')[0].trim());
                return aValue - bValue;
            } else {
                return a.innerText.trim().localeCompare(b.innerText.trim());
            }
        });

        listContainer.innerHTML = '';

        sortedItems.forEach(item => listContainer.appendChild(item));
    });
});